"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = createDeferred;

function createDeferred() {
  var reject, resolve;
  var promise = new Promise(function (promiseResolve, promiseReject) {
    reject = promiseReject;
    resolve = promiseResolve;
  });

  if (!reject || !resolve) {
    throw new Error('Promise is not a ES-compliant and do not run exector immediately');
  }

  return {
    promise: promise,
    reject: reject,
    resolve: resolve
  };
}